import React from "react";
import { FormGroup, Input } from "reactstrap";
import { LocalForm, Control } from "react-redux-form";
import { withTranslation } from "react-i18next";
import classNames from "classnames";

export const TableSearch = ({
  onChange,
  t,
  value,
  debounce = 1000,
  tReady,
  i18nOptions,
  defaultNS,
  reportNS,
  className,
  label,
  ...props
}) => (
  <FormGroup {...props} className={classNames("table-search", className)}>
    <LocalForm component="div" onChange={({ search }) => onChange(search)}>
      <div className="input-group input-group-sm">
        <Control.text
          model=".search"
          debounce={debounce}
          component={Input}
          style={{height:"36px"}}
          placeholder={label || t("search", "Search...")}
        />
        <div className="input-group-append">
          {/* <span className="fa fa-search input-group-text" /> */}
        </div>
      </div>
    </LocalForm>
  </FormGroup>
);

export const enhance = withTranslation();

export default enhance(TableSearch);
